// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2a-a-","label":"CategoryService_label__55EU9","location":"CategoryService_location__3lEfP"};